<template>
  <div>
    <transition name="fade">
      <div :key="'sms_check_dark'" class="pu_dark" v-show="$store.getters.modal.system"></div>
    </transition>
    <transition name="slide">
      <div class="search-block pu_bottom popup_click_hide" v-show="$store.getters.modal.system">
        <div class="pu_bottom_scroll" style="margin: auto">
          <div class="pu_bottom_inner scroll_y"
               style="display: flex; text-align: center; justify-content: space-between; flex-direction: column; border-radius: 10px; min-height: 300px;">
            <div class="systemPopup__text_wrapper">
              <span class="systemPopup__text_message" v-html="$store.getters.modal.systemText"></span>
              <br>
            </div>
            <div style="padding: 0 20% 20px;">
              <a @click="close()" class="fbb_btn">
                ОК
              </a>
            </div>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {SET_SYSTEM_POPUP, SET_STATUS} from '@/store/mutations.type'
  import {mapGetters} from 'vuex'

  export default {
    name: 'SystemPopup',
    methods: {
      close() {
        document.body.classList.remove('overflow')
        this.$store.commit(SET_SYSTEM_POPUP, {status: false, text: ''})
      }
    }
  }
</script>

<style scoped>
    .pu_bottom_inner {
        justify-content: center;
    }
    .systemPopup__text_wrapper {
        padding: 10px 20px;
        padding-top: 50px;
    }
    .systemPopup__text_message {
        display: block;
        white-space: pre-line;
    }
</style>
